module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    staticClass: "bolde"
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('b', [_vm._v("Saturday, October 11")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("7:00 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("roy Horner raised the hood of his raincoat as he exited Planet Fitness in the Midtown Mall in Anchorage. A light mist had filled the air when he’d parked his car and entered the gym. Since then, the mist had turned to heavy rain. "), _c('span', {
    staticClass: "italice"
  }, [_vm._v("Typical October weather")]), _vm._v(", he thought as he hurried to his car. He was still grumpy about having to work on a Saturday. His boss had promised he’d only need him for two or three hours, but the audit had taken all day, and he hadn’t left the office until nearly 5:00 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through the hood of his raincoat, he heard the muffled sound of footsteps hitting the wet pavement behind him. Maybe he’d left something at the gym, and one of the Planet Fitness employees was running after him to return the forgotten item. He turned to see who was behind him and felt what he thought was a wasp sting him in the right arm. Large hands then grabbed him by both shoulders. Troy tried to fight his attacker, but the world faded to black a moment later.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7d4547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap01.vue
// module id = 66
// module chunks = 0